export function enterpriseReducer(state, action) {
  switch (action.type) {
    case "loadEnterprises":
      return {
        ...state,
        enterprises: action.enterprises,
      };
    case "updateEnterprise":
      return {
        ...state,
        enterprises: state.enterprises.map((item) => {
          return item.id == action.enterprise.id ? action.enterprise : item;
        }),
      };
    default:
      throw new Error();
  }
}
